<template>
  <div>
    <!-- modal -->
    <b-modal
      id="uploadFromComputerFormModal" centered size="lg" no-close-on-backdrop ref="uploadFromComputerFormModal" :title="$t('uploadFromComputer.upload_from_computer')" :cancel-title="$t('others.cancel_title')"
      :ok-title="$t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
      <b-row>
        <b-col class="col-lg-12 mb-1">
          <label for="etebs-zip-file-input">{{ $t('uploadFromComputer.zip_file') }}</label>
          <b-input-group>
            <b-form-input size="sm" v-model="zipFileName" readonly />
            <b-input-group-append>
              <b-button size="sm" variant="outline-primary" onclick="document.getElementById('etebsZipFileSelect').click()">{{ $t('others.select') }}</b-button>
            </b-input-group-append>
          </b-input-group>
          <b-form-file size="sm" style="display:none" id="etebsZipFileSelect" accept=".zip" @change="uploadZipFile" :placeholder="$t('uploadFromComputer.select_zip')" :drop-placeholder="$t('uploadFromComputer.select_zip')" />
        </b-col>
        <b-col class="col-lg-12">
          <label for="etebs-excel-file-input">{{ $t('uploadFromComputer.excel_file') }}</label>
          <b-input-group>
            <b-form-input size="sm" v-model="excelFileName" readonly />
            <b-input-group-append>
              <b-button size="sm" variant="outline-primary" onclick="document.getElementById('etebsExcelFileSelect').click()">{{ $t('others.select') }}</b-button>
            </b-input-group-append>
          </b-input-group>
          <b-form-file size="sm" style="display:none" id="etebsExcelFileSelect" accept=".xlsx" @change="uploadExcelFile" :placeholder="$t('uploadFromComputer.select_excel')" :drop-placeholder="$t('uploadFromComputer.select_excel')" />
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: {
    getEtebsList: { type: Function },
  },
  data() {
    return {
      zipFileName: '',
      zipFileBase64: '',
      excelFileName: '',
      excelFileBase64: '',
    }
  },
  methods: {
    showInfo() {
      this.$refs['uploadFromComputerFormModal'].show()
      this.zipFileName = ''
      this.zipFileBase64 = ''
      this.excelFileName = ''
      this.excelFileBase64 = ''
    },
    async uploadZipFile(e) {
      var fileInfo = await this.$getFileInfo(e.target.files[0])
      this.zipFileName = fileInfo.name + '.' + fileInfo.contentType
      this.zipFileBase64 = fileInfo.base64
    },
    async uploadExcelFile(e) {
      var fileInfo = await this.$getFileInfo(e.target.files[0])
      this.excelFileName = fileInfo.name + '.' + fileInfo.contentType
      this.excelFileBase64 = fileInfo.base64
    },
    addOrUpdate() {
      if (!this.zipFileBase64 || !this.excelFileBase64) {
        this.$WarningAlert(this.$t('uploadFromComputer.select_both_files_warning'))
        return
      }
      const data = {
        zipFileName: this.zipFileName,
        zipFileBase64: this.zipFileBase64,
        excelFileName: this.excelFileName,
        excelFileBase64: this.excelFileBase64,
        employeeId: localStorage.getItem('EmployeeId')
      }
      const controller = { name: 'Etebs', actionName: 'UploadFromComputer' }
      const payload = { data: data, controller: controller }
      let loader = this.$loading.show()
      this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
        if (response.data.resultStatus == true) {
          this.$bvModal.hide('uploadFromComputerFormModal')
          this.getEtebsList()
          this.$SaveAlert()
        } else {
          this.$WarningAlert(response.data.resultMessage)
        }
        loader.hide()
      })
    },
  }
}
</script>
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}
[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}
.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}
[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem!important;
    margin-top: -1.5rem!important;
    background-color: #ea5455!important;
    border-radius: 0.358rem!important;
    left: 20px!important
}
</style>
